/**
 * Los tres módulos del producto y su color (rediseño del 18-oct: cada módulo
 * tiene un color fijo, en el cuadro del menú y en la etiqueta de cada página).
 * Desde la marca nueva (25-oct) son los de las capturas de Melanie, medidos:
 * Cotiza violeta (#5B21B6), Compite magenta (#9D2B6B ≈ prixia-sky) y Comercia
 * naranja (#C2410C, orange-700).
 *
 * Los cuadros de marca no cambian con el modo oscuro, así que el ícono va
 * siempre en blanco: los tres fondos son lo bastante oscuros para leerlo.
 */
export type Modulo = 'cotiza' | 'compite' | 'comercia';

export const NOMBRE_DE_MODULO: Record<Modulo, string> = {
  cotiza: 'Cotiza',
  compite: 'Compite',
  comercia: 'Comercia',
};

/** Fondo y color de ícono del cuadro del módulo. */
export const CUADRO_DE_MODULO: Record<Modulo, string> = {
  cotiza: 'bg-prixia-blue text-white',
  compite: 'bg-prixia-sky text-white',
  comercia: 'bg-orange-700 text-white',
};

/** El filete de arriba de la tarjeta del módulo (Inicio). */
export const FILETE_DE_MODULO: Record<Modulo, string> = {
  cotiza: 'border-t-prixia-blue dark:border-t-primary',
  compite: 'border-t-prixia-sky',
  comercia: 'border-t-orange-700',
};

/** El punto de color de una fila o una leyenda del módulo. */
export const PUNTO_DE_MODULO: Record<Modulo, string> = {
  cotiza: 'bg-prixia-blue dark:bg-primary',
  compite: 'bg-prixia-sky',
  comercia: 'bg-orange-700',
};

/** La etiqueta chica con el nombre del módulo (una píldora rellena, como el artefacto). */
export const ETIQUETA_DE_MODULO: Record<Modulo, string> = {
  cotiza: 'bg-prixia-blue text-white',
  compite: 'bg-prixia-sky text-white',
  comercia: 'bg-orange-700 text-white',
};
